var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 6,
  fill: "none",
  viewBox: "0 0 10 6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#475569",
  fillRule: "evenodd",
  d: "M.53.53c.26-.26.682-.26.942 0l3.529 3.528L8.529.53a.667.667 0 0 1 .943.942l-4 4a.667.667 0 0 1-.943 0l-4-4a.667.667 0 0 1 0-.942",
  clipRule: "evenodd"
})));
export default SvgChevronDown;